<div>
  <app-navbar></app-navbar>
</div>
<div>
  <router-outlet></router-outlet>
</div>
